export default __webpack_public_path__ + "static/tab5Img-73d5e8a32ef9dcc910bb85981e4e9342.png";